import { connect } from 'react-redux';
import { flow } from 'fp-ts/function';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { editFormMergeProps } from '../../entityManagement/utils';
import { isEditing, getSelectedEntityId } from '../../entityManagement/selectors';
import { startEntityDeleting, stopEntityEditing } from '../../entityManagement/actions';
import AddressForm from '../components/AddressForm';
import { getSelectedAddressLine1 } from '../selectors';
import { editAddress } from '../actions';
import EntityTitle from '../../../components/commander-ui/EntityTitle';
import { AddressFormValues } from '../types';

const getTitle = flow(
    getSelectedAddressLine1,
    (addressLine) => addressLine || <LocalizedText textKey={TextKey.Address} />,
    (title) => <EntityTitle>{title}</EntityTitle>
);

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        opened: isEditing,
        id: getSelectedEntityId,
        title: getTitle,
        modal: () => true,
    }),
    (dispatch: CommanderThunkDispatch, { scope, ownerId, isCompany, ...restOwnProps }) => ({
        onSubmit: async (values: AddressFormValues) => dispatch(editAddress(values, ownerId, scope)),
        onClose: () => dispatch(stopEntityEditing(scope)),
        onDelete: (id: string) => dispatch(startEntityDeleting(id, scope)),
        ...restOwnProps,
    }),
    editFormMergeProps
)(AddressForm);
